import * as Team from './team.ts';
import * as UserTasks from './user_tasks.ts';
import * as Attachments from './attachments.ts';
import * as TaskChecklists from './task_checklists.ts';
import * as ChecklistTasks from './checklist_tasks.ts';
import * as Contacts from './contacts.ts';
import * as CustomFields from './custom_fields.ts';
import * as Quickstart from './quickstart.ts';
import * as TaskChecklistClones from './task_checklist_clones.ts';

export const Api = {
  Team,
  UserTasks,
  Attachments,
  TaskChecklists,
  TaskChecklistClones,
  ChecklistTasks,
  Contacts,
  CustomFields,
  Quickstart,
};

export const ApiPlugin = {
  install(app: {
    config: {
      globalProperties: {
        $api: {
          Team: typeof Team;
          UserTasks: typeof UserTasks;
          Attachments: typeof Attachments;
          TaskChecklists: typeof TaskChecklists;
          TaskChecklistClones: typeof TaskChecklistClones;
          ChecklistTasks: typeof ChecklistTasks;
          Contacts: typeof Contacts;
          CustomFields: typeof CustomFields;
          Quickstart: typeof Quickstart;
        };
      };
    };
  }) {
    app.config.globalProperties.$api = Api;
  },
};
